import { render, staticRenderFns } from "./news-hot.vue?vue&type=template&id=da9d9ec6&scoped=true&"
import script from "./news-hot.vue?vue&type=script&lang=js&"
export * from "./news-hot.vue?vue&type=script&lang=js&"
import style0 from "./news-hot.vue?vue&type=style&index=0&id=da9d9ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9d9ec6",
  null
  
)

export default component.exports